// src/components/ReservationParticipantFields.js
import React from 'react';
import { User, Phone } from 'lucide-react';

function ReservationParticipantFields({ index, participant, onChange, onPhoneBlur, isPrimaryUser }) {
    
    // Função para aplicar a máscara (00) 00000-0000 enquanto o usuário digita
    const handlePhoneChange = (e) => {
        let value = e.target.value.replace(/\D/g, ''); 
        
        if (value.length > 11) {
            value = value.substring(0, 11);
        }

        let formatted = value;
        if (value.length > 2) {
            formatted = `(${value.substring(0, 2)}) ${value.substring(2)}`;
        }
        if (value.length > 7) {
            formatted = `(${value.substring(0, 2)}) ${value.substring(2, 7)}-${value.substring(7, 11)}`;
        }

        onChange(index, 'phone', formatted);
    };

    // Dispara a verificação na API apenas quando o usuário clica fora do campo (onBlur)
    const handleBlur = (e) => {
        if (onPhoneBlur) {
            onPhoneBlur(index, e.target.value);
        }
    };

    // Variável que define se o campo NOME deve ser bloqueado
    const isLocked = isPrimaryUser || participant.hasSubscriptionHistory;

    return (
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            {/* NAME INPUT */}
            <div className="relative">
                <div className={`absolute left-4 top-1/2 -translate-y-1/2 ${isLocked ? 'text-stone-300' : 'text-stone-400'}`}>
                    <User size={18} />
                </div>
                <input
                    type="text"
                    placeholder="Nome e Sobrenome"
                    value={participant.name}
                    onChange={(e) => onChange(index, 'name', e.target.value)}
                    // 👇 Mudamos readOnly para disabled para bloquear seleção e cursor de texto
                    disabled={isLocked}
                    className={`w-full border border-[#dbcdac]/60 rounded-xl py-3 pl-11 pr-4 focus:outline-none transition-all shadow-sm
                        ${isLocked 
                            ? 'bg-stone-100 text-stone-500 cursor-not-allowed select-none' 
                            : 'bg-white text-stone-700 focus:border-[#528a89]'
                        }
                    `}
                />
            </div>

            {/* PHONE INPUT */}
            <div className="relative">
                <div className={`absolute left-4 top-1/2 -translate-y-1/2 ${participant.duplicateError ? 'text-red-400' : 'text-stone-400'}`}>
                    <Phone size={18} />
                </div>
                <input
                    type="tel"
                    placeholder="(00) 00000-0000"
                    value={participant.phone}
                    onChange={handlePhoneChange}
                    onBlur={handleBlur} 
                    className={`w-full border rounded-xl py-3 pl-11 pr-4 text-stone-700 focus:outline-none transition-all shadow-sm
                        ${participant.duplicateError 
                            ? 'border-red-400 focus:border-red-500 bg-red-50' 
                            : 'bg-white border-[#dbcdac]/60 focus:border-[#528a89]'
                        }
                    `}
                />
                
                {participant.hasSubscriptionHistory && !participant.duplicateError && (
                    <span className="absolute -top-2.5 right-4 bg-[#528a89] text-white text-[10px] font-bold px-2 py-0.5 rounded-full shadow-sm pointer-events-none">
                        Assinante Localizado
                    </span>
                )}
                
                {participant.duplicateError && (
                    <span className="absolute -bottom-5 left-2 text-red-500 text-xs font-medium pointer-events-none">
                        Número já adicionado à mesa.
                    </span>
                )}
            </div>
        </div>
    );
}

export default ReservationParticipantFields;